import { DATE_PICKER_FORMAT } from '@constants/date';
import { DatePickerProps, DatePicker as MuiDatePicker } from '@mui/x-date-pickers';
import { Calendar2Icon } from 'components/SvgIcons/Calendar2Icon';
import { isValid } from 'date-fns';
import React from 'react';
import { inputDateValue, outputDateValue } from 'utils/InputOutputDateFormat';

const OpenPickerIcon = () => <Calendar2Icon fontSize="small" />;

const DatePicker = React.forwardRef<DatePickerProps<Date, Date> & { clearable?: boolean }, any>(
  ({ clearable = true, ...props }, ref) => {
    const isValidDate = (date: Date) => {
      const currentDate = new Date();
      if (!isValid(date)) return false;
      const year = date.getFullYear();
      return year >= currentDate.getFullYear() - 10 && year <= currentDate.getFullYear() + 10;
    };

    return (
      <MuiDatePicker
        ref={ref}
        inputFormat={DATE_PICKER_FORMAT}
        mask="__/__/____"
        components={{ OpenPickerIcon }}
        OpenPickerButtonProps={{
          sx: {
            color: 'common.black',
          },
        }}
        {...props}
        value={props.value ? inputDateValue(props.value) : null}
        onChange={(value: Date) => {
          if (clearable) {
            if (value === null) {
              props.onChange?.(outputDateValue(value));
            } else if (isValidDate(value)) {
              props.onChange?.(outputDateValue(value));
            }
          } else if (isValid(value)) {
            props.onChange?.(outputDateValue(value));
          }
        }}
      />
    );
  }
);

export default DatePicker;
